export default __webpack_public_path__ + "static/media/check-circle-full.917f2a5a.svg";